/*
 * @Author: chen zhen
 * @Date: 2018-06-22 15:10:52
 * @Last Modified by: Nie Wei
 * @Last Modified time: 2019-11-04 16:15:05
 * @Description: 将axios 绑定到 vue 上
 */
import _axios from 'axios'

// let store = null

// http request 拦截器
_axios.interceptors.request.use(config => config, err => Promise.reject(err))
// (config) => {
//   // 在get请求的时候，对传入的参数进行设定
//   // if (store === null) return config
//   // let token = store.getters['user/token']
//   // if (token) config.headers.token = `${token}`
//   return config
// },
//   (err) => {
//     // TODO 添加对请求错误的处理
//     return Promise.reject(err)
//   }
// )

// http response 拦截器
_axios.interceptors.response.use(
  (response) => {
    // 当正常的返回值的时候，直接将data进行返回
    if (response.data) return response.data
    return null
  },
  err => Promise.reject(err)
  // (err) => {
  //   return Promise.reject(err)
  // }
)

// 向外暴露，单独引用axios
export const axios = _axios

export default {
  install(Vue) {
    Vue.prototype.$axios = _axios
    Vue.axios = _axios
  },
  // setStore(_store) {
  //   store = _store
  // },
}
